<template>

  <div>

    <t-input-person-list v-if="mount" :show="modalSearch" :entity-person-type="entityPersonType"
                         :product-code-full="codeLabel"
                         @onClose="onModalSearchClose()" @onSelected="onSelected"/>


    <div class="d-flex align-items-start">

      <t-input @focusin="searchFocusIn" upper not-autocomplete @keyup.native="executeFastSearch"
               @focusout="searchFocusOut"
               :fixed="localFixed"
               :add-error="addError"
               :form-status="status" :form-command="command" :required="required" class-input="input-with-search"
               :label="text"
               v-model="codeLabel">

        <template #input-group-append v-if="!localFixed">

          <div style="position: absolute; left: -2px; top: 35px; background-color: #8b1833">

            <div tabindex="-1" :class="{'show':fastSearchList.length > 0}"
                 class="rm-pointers dropdown-menu dropdown-menu-left not-transform" style="min-width: 200px;">
              <!--              <h6 tabindex="-1" class="dropdown-header">
                              Busca
                            </h6>-->
              <button type="button" v-for="(item,index) in fastSearchList" :key="index" tabindex="0"
                      @click="setFastSearchByIndex(index)" :class="{'item-dropdown-select': index === fastSearchCursor}"
                      class="dropdown-item one-per-line">

                <div v-html="getDetailSearchList(item)"></div>

              </button>

              <!--
              <div tabindex="-1" class="dropdown-divider"></div>
           <h6 tabindex="-1" class="dropdown-header">Últimas pesquisas</h6>
              <button type="button" tabindex="0" class="dropdown-item active">
                Germany
              </button>
              <button type="button" tabindex="0" class="dropdown-item">
                Italy
              </button>-->
            </div>

          </div>

          <t-button icon-search outline-secondary
                    v-if="command === 'insert' || command === 'update'"
                    @click="openModalSearch()"/>
        </template>

      </t-input>

      <b-col class="text-left" v-if="!disableName" style="margin-top: 22px;padding-right: 0px;">

        <div class="vs--disabled_label form-control"
             style="margin-bottom: 8px; text-overflow: ellipsis; overflow: hidden; height: 33px !important">
          <span>{{ name }}</span>
        </div>

      </b-col>

    </div>

  </div>

</template>
<script>
import EntityPersonType from "@/model/types/modules/general/EntityPersonType";
import tInputPersonList from "@/components/template/form/finder/t-input-person-list";
import personService from "@/services/modules/general/Person.service";
import ui from "@/assets/scripts/ui";
import functionsMixins from "@/mixins/page/functionsMixins";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";


export default {
  name: 't-input-person',
  components: {tInputPersonList},
  mixins: [functionsMixins],
  data() {
    return {
      modalId: "modal-person-search",
      path: "",
      text: "",
      busy: false,
      personId: 0,
      clicked: false,
      codeLabel: "",
      entityPersonType: 0,//Tipo da entidade de person montada (cliente, fornecedor, credor, etc.)
      name: "",
      onSending: false,
      mount: false,
      modalSearch: false,
      fastSearchCursor: -1,//Posição do cursor
      enableCloseFastSearch: true,//Trava fechamento da listagem para execução de alguma tarefa
      fastSearchList: [],
      localFixed: false,
      accountModule: "",
    }
  },
  props: {
    value: {
      type: null,
      default: ""
    },
    disableName: Boolean,
    required: {/*ATENÇÃO PARA FUNCIONAR É NECESSÁRIO ENVIAR O STATUS E COMANDO*/
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: "",
    },
    command: {
      type: String,
      default: "insert",
    },
    addError: {
      type: String,
      default: ""
    },
    fixed: Boolean,
    customer: Boolean,
    creditor: Boolean,
    supplier: Boolean,
    executor: Boolean,

  },
  mounted() {

    this.accountModule = ui.getAccountModule()

    if (this.customer) {
      this.entityPersonType = EntityPersonType.type.CUSTOMER
    } else if (this.creditor) {
      this.entityPersonType = EntityPersonType.type.CREDITOR
    } else if (this.supplier) {
      this.entityPersonType = EntityPersonType.type.SUPPLIER
    } else if (this.executor) {
      this.entityPersonType = EntityPersonType.type.EXECUTOR
    }

    this.modalId += '-' + this.entityPersonType

    this.path = EntityPersonType.getPath(this.entityPersonType)
    this.text = EntityPersonType.getText(this.entityPersonType)

    /*Especificações de nomes por módulos*/
    if (this.accountModule === 'estate') {

      if (this.customer)
        this.text = 'Locador'


    }


    this.setFixed()
    this.getPersonResume(this.value)

  },
  methods: {

    setFixed() {
      this.localFixed = this.fixed

      if (this.command === 'delete' || this.command === 'view') {
        this.localFixed = true
      }

    },

    onModalSearchClose() {
      this.modalSearch = false
    },

    onSelected(personId) {
      this.onModalSearchClose()
      this.$emit("input", personId)
    },

    openModalSearch() {

      document.activeElement.blur()

      this.modalSearch = true

      if (this.mount) {
        this.$bvModal.show(this.modalId)
      } else {

        this.mount = true

        setTimeout(() => {
          this.$bvModal.show(this.modalId)
        }, 200)

      }

    },

    async getPersonResume(personId) {

      if (personId === 0) {
        this.codeLabel = ""
        this.name = ""
      } else {

        this.busy = true

        await this.getResumePerson('id', personId).then(() => {
          this.setBlackout(false)
        })

      }

    },

    getDetailSearchList(item) {

      const codeLabel = "" + this.codeLabel

      if (codeLabel.indexOf(".") === -1 && !isNaN(codeLabel) &&
          !isNaN(parseFloat(codeLabel))) {

        //Não evidenciar pesquisa
        const parts = [];

        if (item.federalTaxpayer) parts.push(item.federalTaxpayer);
        if (item.city) parts.push(item.city);
        if (item.provinceAbbreviation) parts.push(item.provinceAbbreviation);
        if (this.text && item.personNumber) parts.push(`Cód. ${this.text}: ${item.personNumber}`);

        const subtitle = parts.join(' - ');


        return "<div>" + item.name + "</div><small>" + subtitle + "</small>"

      } else {

        //Evidencia pesquisa

        const parts = [];

        if (item.federalTaxpayer) parts.push(ui.highlightSearch(item.federalTaxpayer, this.codeLabel));
        if (item.city) parts.push(item.city);
        if (item.provinceAbbreviation) parts.push(item.provinceAbbreviation);
        if (this.text && item.personNumber) parts.push(`Cód. ${this.text}: ${item.personNumber}`);

        const subtitle = parts.join(' - ');


        return "<div>" + ui.highlightSearch(item.name, this.codeLabel) + "</div><small>" + subtitle + "</small>"

      }

    },


    async setFastSearchByIndex(index) {

      this.clicked = true
      this.codeLabel = this.fastSearchList[index].personNumber
      await this.getPersonId()
      this.clicked = false


    },

    clearFastSearch() {
      this.fastSearchCursor = -1
      this.enableCloseFastSearch = true
      this.fastSearchList = []
    },

    async executeFastSearch(event) {

      if (this.fastSearchList.length > 0) {

        if (event.which === 38) {
          //Subir

          this.fastSearchCursor--;

          if (this.fastSearchCursor < 0) {
            //Não inicializado e será o último
            this.fastSearchCursor = this.fastSearchList.length - 1
          }

        } else if (event.which === 40) {
          //Descer

          this.fastSearchCursor++;

          if (this.fastSearchCursor > (this.fastSearchList.length - 1)) {
            //Não inicializado e será o último
            this.fastSearchCursor = 0
          }

        } else if (event.which === 13) {

          this.clicked = true


          //Caso não selecionado, será subentendido o primeiro da lista
          if (this.fastSearchCursor < 0)
            this.fastSearchCursor = 0

          this.codeLabel = this.fastSearchList[this.fastSearchCursor].personNumber

          await this.getPersonId()

          this.clicked = false

          document.activeElement.blur()


        } else {
          await this.getFastSearchTop()
        }

      } else {
        await this.getFastSearchTop()
      }

    },

    async getFastSearchTop() {

      const codeLabel = "" + this.codeLabel

      if (codeLabel !== '') {

        let params = new URLSearchParams()

        if (codeLabel.indexOf(".") === -1 && !isNaN(codeLabel) &&
            !isNaN(parseFloat(codeLabel))) {

          //Pesquisa pelo código do cliente
          params.set("personNumber", codeLabel)

        } else {
          //Pesquisa pelo default
          params.set("default", codeLabel)
        }

        params.set("top", "5")

        await crudGeneral.list(this.path + "/resumeTop", params)
            .then(list => {
              this.fastSearchList = list
            })
            .catch(error => {
              console.log('Erro externo: ' + error)
            })

      } else {
        this.clearFastSearch()
      }

    },

    searchFocusIn() {

      //Desabilita o submit, caso existir para evitar que o produto ainda não tenha carregado ou esteja em alteração
      this.setDisabledButtonSubmit(true)

    },

    async searchFocusOut() {

      if(!this.clicked){

        setTimeout(async () => {
          this.clearFastSearch()
          await this.getPersonId()
        }, 100)

      }

    },

    async getPersonId() {

      if (this.codeLabel === '') {
        this.personId = 0
      } else {
        await this.getResumePerson('code', this.codeLabel)
      }

      this.$emit("input", this.personId)

      //Emite somente se for encontrado corretamente
      if (this.personId > 0)
        this.$emit("focusout", this.personId)

      //Saida do foco habilita novamente
      setTimeout(() => {
        //Tempo necessário para finalizar carregamento do produto
        this.setDisabledButtonSubmit(false)
      }, 500)

    },

    async getResumePerson(type, param) {

      await personService.getResume(this.entityPersonType, type, param).then(resume => {

        this.personId = resume.personId
        this.codeLabel = resume.personNumber
        this.name = resume.name
        this.busy = false

        this.$emit("onResume", resume)

      }).catch(error => {

        if (error.response) {
          if (error.response.status === 500) {
            ui.msg(this, 'Informação', error.response.data.message)
          }
        } else if (error !== '') {
          ui.msg(this, "Erro", error)
        }
      })

    }

  },
  watch: {
    async value(v) {
      await this.getPersonResume(v)
      this.$emit("change", v)
    },
    fixed(v) {
      this.localFixed = v
      this.setFixed()
    },
    command() {
      this.setFixed()
    },
    /*modalSearch(v) {

    }*/

  },
}
</script>